export const formatOrganizationLocation = (location) => {
  if (!location) return '';

  const address = [location.address, location.city].filter(Boolean).join(', ');

  if (location.name && address) return `${location.name} - ${address}`;

  return location.name || address || location.city || '';
};
